import {
  OrganizationRole,
  organizationRoleOrder,
} from '@kirin/api-client/contracts/organizations';

/**
 * The member's most privileged role, as the role dropdown selects it. No roles
 * reads as Member here; the read-only RoleBadge shows "No Role" instead.
 */
export function getHighestRole(roles: string[]): string {
  if (!roles?.length) {
    return OrganizationRole.Member;
  }
  return roles.reduce((highest, role) => {
    const currentPriority =
      organizationRoleOrder[role as OrganizationRole] ?? 3;
    const highestPriority =
      organizationRoleOrder[highest as OrganizationRole] ?? 3;
    return currentPriority < highestPriority ? role : highest;
  }, roles[0]);
}
